import React from "react";
import { Link } from "react-router-dom";
import "./NotFoundPage.scss";

export default function NotFoundPage() {
  const hasToken = Boolean(localStorage.getItem("token") || sessionStorage.getItem("token"));
  const backRoute = hasToken ? "/dashboard" : "/login";
  const backgroundImageUrl = `${process.env.PUBLIC_URL}/bck.jfif`;

  return (
    <section
      className="error-page h-p100 hold-transition theme-primary bg-img not-found-template"
      style={{
        backgroundImage: `url(${backgroundImageUrl})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        minHeight: "100dvh",
        width: "100vw",
      }}
    >
      <div className="container h-p100">
        <div className="row h-p100 align-items-center justify-content-center text-center">
          <div className="col-lg-7 col-md-10 col-12">
            <div className="rounded10 p-50 not-found-card">
              <img
                className="max-w-200"
                src={`data:image/svg+xml;utf8,${encodeURIComponent(`
                  <svg xmlns="http://www.w3.org/2000/svg" width="300" height="190" viewBox="0 0 300 190">
                    <rect width="300" height="190" rx="16" fill="#ffffff"/>
                    <text x="50%" y="45%" dominant-baseline="middle" text-anchor="middle" font-size="76" font-family="Arial, sans-serif" fill="#6f59c4" font-weight="700">404</text>
                    <text x="50%" y="68%" dominant-baseline="middle" text-anchor="middle" font-size="18" font-family="Arial, sans-serif" fill="#4b5563">Page Not Found</text>
                  </svg>
                `)}`}
                alt="404"
              />
              <h1>Page Not Found!</h1>
              <h3>Looks like, page doesn&apos;t exist</h3>
              <div className="my-30">
                <Link to={backRoute} className="btn btn-danger">
                  Back to dashboard
                </Link>
              </div>

              <form className="search-form mx-auto mt-30 w-p75" onSubmit={(e) => e.preventDefault()}>
                <div className="input-group rounded5 overflow-h">
                  <input type="text" name="search" className="form-control" placeholder="Search" />
                  <button type="submit" name="submit" className="btn btn-danger btn-sm">
                    <i className="fa fa-search"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
